import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private httpOptions = {
    headers: new HttpHeaders({
      'Authorization': '',
    })
  };

  constructor(private http:HttpClient ) {}

  getUsuario(Usuario:string,Password:string):Observable<any>{ 

    Usuario=Usuario.trim();
    Password=Password.trim();

    return this.http.post<any>(`${environment.base}${environment.catalogos_port}auth/login`,{userName: Usuario, password: Password}) ;   

    ///return this.http.get<any>('http://localhost:7039/vendedores/SC-1');
  }

  getSession(sucursalId:number): Observable<any>{
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}auth/current/${sucursalId}`);
  }

  validarTokenValido(){
    let aux = new Date((localStorage.getItem("date_token")))
    let actual = new Date()
    const diferenciaMilisegundos = Math.abs(actual.getTime() - aux.getTime());
    const diferenciaMinutos = diferenciaMilisegundos / (1000 * 60);
    return diferenciaMinutos < parseInt(localStorage.getItem("minutesToExpire")) ? true : false
  }

  /*reautenticarToken(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}refresh-user/true`, body);
  }*/

  reautenticarToken(renew: boolean, body) {
        const headers = {
      'content-type': 'application/json',
      'ApiKey': `${environment.apikey}`
    }

    const url = `${environment.base}${environment.catalogos_port}refresh-user/${renew}`
    return this.http.post<any>(url, body, {headers: headers});
  }


  public haySesionActiva= ()=> {
    const SesionActiva1:Boolean = (
      localStorage.getItem("id")==null ||
      localStorage.getItem("userName")==null ||
      localStorage.getItem("token")==null ||
      localStorage.getItem("minutesToExpire")==null
    );

    if (SesionActiva1) return false;

    const SesionActiva2:Boolean =(
      localStorage.getItem("id") != '' &&
      localStorage.getItem("userName") != '' &&
      localStorage.getItem("token") != '' &&
      localStorage.getItem("minutesToExpire") != '' &&
      localStorage.getItem("date_token") != ''
    );

    if (SesionActiva2) return true;

    return false;

  }

  public setVariablesSesion= (itemUsuario)=> { 
    localStorage.setItem("id", itemUsuario.id);
    localStorage.setItem("userName", itemUsuario.userName);
    localStorage.setItem("firstName", itemUsuario.name);
    localStorage.setItem("lastName", itemUsuario.lastName);
    localStorage.setItem("profile", itemUsuario.profiles[0].name);
    localStorage.setItem("minutesToExpire", itemUsuario.minutesToExpire);
    localStorage.setItem("token", itemUsuario.token);
    localStorage.setItem("date_token", new Date().toString())
    localStorage.setItem('userProfiles', JSON.stringify(itemUsuario.profiles));
  }
  public setProfile = (itemUsuario)=> { 
    localStorage.setItem("profile", itemUsuario.perfil);
    localStorage.setItem("profileId", itemUsuario.perfilId);
  }

  public getVariableSesion= (Key:string)=> { 
    return localStorage.getItem(Key);
  }

  public LogOutSession =()=>{
    //--Destruir las variables de sesión
		localStorage.removeItem("accesoCorrecto");
		localStorage.removeItem("nombreUsuario");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
		localStorage.removeItem("password");
		localStorage.removeItem("profile");
		localStorage.removeItem("minutesToExpire");
		localStorage.removeItem("userName");
		localStorage.removeItem("token");
		localStorage.removeItem("id");
		localStorage.removeItem("date_token");
  }

  public getToken(){
    return localStorage.getItem('token')
  }

  public setVariableSession= (Key:string, value:string)=> { 
    return localStorage.setItem(Key, value);
  }
}